/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPhoneSmartIcon16Regular = forwardRef('TechPhoneSmartIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 11.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M5.875 5.75a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 3.75A2.75 2.75 0 0 1 4.75 1h5.5A2.75 2.75 0 0 1 13 3.75v8.5A2.75 2.75 0 0 1 10.25 15h-5.5A2.75 2.75 0 0 1 2 12.25v-8.5ZM4.75 2.5c-.69 0-1.25.56-1.25 1.25v8.5c0 .69.56 1.25 1.25 1.25h5.5c.69 0 1.25-.56 1.25-1.25v-8.5c0-.69-.56-1.25-1.25-1.25h-5.5Z" })));
});
